var _defs, _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.723,
    height: 82.723,
    viewBox: "0 0 82.723 82.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.151;}.b{fill:#fff;fill-rule:evenodd;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 41.362,
    cy: 41.362,
    rx: 41.362,
    ry: 41.362,
    transform: "translate(0 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.144,10A19.141,19.141,0,0,0,13.38,40a.957.957,0,0,1,.12.823l-1.944,6.506,6.371-2.2a.955.955,0,0,1,.823.1A19.15,19.15,0,1,0,29.144,10Zm-7.837,8.346L24.792,24.1,23.341,25.54a.959.959,0,0,0-.15,1.152c2.214,3.834,4.836,6.816,8.51,8.435a.96.96,0,0,0,1.062-.194L34.3,33.392l5.624,3.515a5.31,5.31,0,0,1-2.363,2.722,5.744,5.744,0,0,1-3.889.359c-3-.623-6.62-2.978-9.572-6s-5.236-6.691-5.818-9.677a5.616,5.616,0,0,1,.389-3.8,4.836,4.836,0,0,1,2.632-2.169Z",
    transform: "translate(11.754 12.217)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.609a2b3ad9347ff632831b14a1002aca.svg";
export { ForwardRef as ReactComponent };